module.exports = __webpack_public_path__ + "img/machine.5ac5d770.svg";